module.exports = __webpack_public_path__ + "static/media/koig_interiors(1).175f262e.mp4";